// The organization block of the auth-page footer: name · representative, then the address.
//
// Extracted because the footer is inlined into all three auth screens (login, signup, password-reset)
// rather than living in a shared footer component. Three inlined copies of the same markup is how the
// three screens would drift apart, and the values they show are now fetched rather than typed — so the
// fetch, the null handling and the labelling live in one place instead of three.

import { useTranslation } from 'react-i18next';
import { useInstitution } from './useInstitution';

/**
 * Renders only the rows it actually has values for.
 *
 * Nothing here has a hardcoded fallback: while the fetch is in flight, and if it fails, the rows simply
 * do not render. That is deliberate — a placeholder string is the stale copy this work exists to remove,
 * and shipped placeholders are what put `홍길동` and a sample business-registration number in front of a
 * customer for months (SHCT-624).
 *
 * The separator between the name and the representative appears only when both are present, so a missing
 * representative cannot leave a dangling bar.
 */
export function AuthFooterOrganization() {
  const { t } = useTranslation('auth');
  const { name, address, representative } = useInstitution();

  return (
    <>
      {(name || representative) && (
        <div className="login-page__footer-info">
          {name && <span>{name}</span>}
          {name && representative && <span className="login-page__footer-sep">|</span>}
          {representative && (
            <span>
              {t('footer.representativeLabel')}: {representative}
            </span>
          )}
        </div>
      )}

      {address && (
        <div className="login-page__footer-info">
          {t('footer.addressLabel')}: {address}
        </div>
      )}
    </>
  );
}
